import React from 'react';
import { FadeIn } from '../components/ui/FadeIn';
import { Button } from '../components/ui/Button';
import { SectionHeading } from '../components/ui/SectionHeading';
import { Check } from 'lucide-react';
export function BridalServices() {
  return <div className="bg-ivory" data-id="element-135">
      {/* Hero Section */}
      <section className="relative h-[70vh] min-h-[500px] flex items-center justify-center overflow-hidden" data-id="element-136">
        <div className="absolute inset-0 z-0" data-id="element-137">
          <img src="https://cdn.magicpatterns.com/uploads/6YF1MFRxyEqv2dVrqrd2mR/8a.png" alt="Bride in lace gown admiring her look in a mirror" className="w-full h-full object-cover object-center" data-id="element-138" />
          <div className="absolute inset-0 bg-espresso/40 mix-blend-multiply" data-id="element-139" />
        </div>

        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto mt-20" data-id="element-140">
          <FadeIn delay={0.2} data-id="element-141">
            <h1 className="text-5xl md:text-7xl text-ivory mb-6 text-balance" data-id="element-142">
              The Bridal Experience
            </h1>
          </FadeIn>
          <FadeIn delay={0.4} data-id="element-143">
            <p className="text-lg md:text-xl text-cream font-light text-balance" data-id="element-144">
              Luxury bridal beauty, thoughtfully curated for your wedding day.
            </p>
          </FadeIn>
        </div>
      </section>

      {/* Intro Section */}
      <section className="py-24 px-6" data-id="element-145">
        <div className="max-w-3xl mx-auto text-center" data-id="element-146">
          <FadeIn data-id="element-147">
            <p className="text-xl text-taupe font-light leading-relaxed" data-id="element-148">
              Our bridal offerings are designed for the bride who values
              elegance, preparation, and a seamless on-site experience. Each
              package is carefully composed to enhance your natural beauty while
              bringing ease, refinement, and exceptional care to every moment of
              your bridal journey.
            </p>
          </FadeIn>
        </div>
      </section>

      {/* Bridal Packages Section */}
      <section className="py-16 px-6 bg-cream" data-id="element-149">
        <div className="max-w-7xl mx-auto" data-id="element-150">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-151">
            {/* Package 1 */}
            <FadeIn delay={0.1} className="bg-white p-10 md:p-12 border border-champagne/50 flex flex-col" data-id="element-152">
              <h3 className="text-3xl text-espresso mb-2" data-id="element-153">
                The Signature Bride Experience
              </h3>
              <p className="text-sm tracking-widest text-gold uppercase mb-8" data-id="element-154">
                Investment $470
              </p>
              <div className="w-full h-[1px] bg-champagne/50 mb-8" data-id="element-155" />
              <ul className="space-y-4 flex-grow mb-10" data-id="element-156">
                {['Brow design with waxing or threading', 'Personalized makeup trial', 'Wedding day makeup', 'Touch-up kit', 'On-site service in Charlotte, NC'].map((item, i) => <li key={i} className="flex items-start gap-3 text-taupe font-light" data-id="element-157">
                    <Check className="w-5 h-5 text-gold shrink-0 mt-0.5" data-id="element-158" />
                    <span data-id="element-159">{item}</span>
                  </li>)}
              </ul>
              <Button href="/contact" variant="outline" className="w-full" data-id="element-160">
                Inquire Now
              </Button>
            </FadeIn>

            {/* Package 2 */}
            <FadeIn delay={0.2} className="bg-espresso text-ivory p-10 md:p-12 border border-gold shadow-xl flex flex-col relative lg:-mt-8 lg:mb-8 z-10" data-id="element-161">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-gold text-white text-[0.65rem] tracking-[0.2em] uppercase px-4 py-1" data-id="element-162">
                Most Loved
              </div>
              <h3 className="text-3xl mb-2" data-id="element-163">
                The Luxury Bridal Glow Experience
              </h3>
              <p className="text-sm tracking-widest text-champagne uppercase mb-8" data-id="element-164">
                Investment $620
              </p>
              <div className="w-full h-[1px] bg-taupe/50 mb-8" data-id="element-165" />
              <ul className="space-y-4 flex-grow mb-10" data-id="element-166">
                {['Brow design with waxing or threading', 'Bridal glow facial', 'Personalized makeup trial', 'Wedding day makeup', 'Touch-up kit', 'On-site service', 'Skin prep guidance'].map((item, i) => <li key={i} className="flex items-start gap-3 text-cream font-light" data-id="element-167">
                    <Check className="w-5 h-5 text-champagne shrink-0 mt-0.5" data-id="element-168" />
                    <span data-id="element-169">{item}</span>
                  </li>)}
              </ul>
              <Button href="/contact" variant="primary" className="w-full bg-ivory text-espresso hover:bg-cream" data-id="element-170">
                Inquire Now
              </Button>
            </FadeIn>

            {/* Package 3 */}
            <FadeIn delay={0.3} className="bg-white p-10 md:p-12 border border-champagne/50 flex flex-col" data-id="element-171">
              <h3 className="text-3xl text-espresso mb-2" data-id="element-172">
                The Ultimate VIP Bride Experience
              </h3>
              <p className="text-sm tracking-widest text-gold uppercase mb-8" data-id="element-173">
                Investment $740
              </p>
              <div className="w-full h-[1px] bg-champagne/50 mb-8" data-id="element-174" />
              <ul className="space-y-4 flex-grow mb-10" data-id="element-175">
                {['Brow design with waxing or threading', 'Bridal glow facial', 'Extended makeup trial', 'Wedding day makeup', 'Luxury touch-up kit', 'On-site service', 'Bridal Renewal Massage'].map((item, i) => <li key={i} className="flex items-start gap-3 text-taupe font-light" data-id="element-176">
                    <Check className="w-5 h-5 text-gold shrink-0 mt-0.5" data-id="element-177" />
                    <span data-id="element-178">{item}</span>
                  </li>)}
              </ul>
              <Button href="/contact" variant="outline" className="w-full" data-id="element-179">
                Inquire Now
              </Button>
            </FadeIn>
          </div>
        </div>
      </section>

      {/* Bridal Add-Ons Section */}
      <section className="py-24 px-6" data-id="element-180">
        <div className="max-w-4xl mx-auto" data-id="element-181">
          <FadeIn data-id="element-182">
            <SectionHeading title="Enhancements" data-id="element-183" />
          </FadeIn>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-6" data-id="element-184">
            {[{
            name: 'Mother of the Bride or Groom Makeup',
            price: '$150'
          }, {
            name: 'Bridesmaid Makeup',
            price: '$135 per person'
          }, {
            name: 'Junior Bridesmaid Makeup',
            price: '$95'
          }, {
            name: 'Flower Girl Light Glam',
            price: '$45'
          }, {
            name: 'Additional Makeup Trial',
            price: '$150'
          }, {
            name: 'Bridal Brow Design',
            price: '$45'
          }, {
            name: 'Additional Glow Facial',
            price: '$160'
          }, {
            name: 'Bridal Renewal Massage',
            price: '$140'
          }, {
            name: 'Wedding Day MakeUp',
            price: '$320'
          }, {
            name: 'Travel Outside Charlotte',
            price: 'Starting at $50'
          }, {
            name: 'Early Morning Booking Before 7 AM',
            price: '$100'
          }, {
            name: 'Holiday / Peak Date Booking Fee',
            price: 'Starting at $100'
          }].map((addon, i) => <FadeIn key={i} delay={i * 0.05} className="flex items-end justify-between border-b border-champagne/50 pb-3" data-id="element-185">
                <span className="text-espresso pr-4" data-id="element-186">{addon.name}</span>
                <span className="text-taupe font-light whitespace-nowrap" data-id="element-187">
                  {addon.price}
                </span>
              </FadeIn>)}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-32 bg-warm-beige/10 px-6 text-center" data-id="element-188">
        <FadeIn data-id="element-189">
          <h2 className="text-4xl md:text-5xl font-serif text-espresso mb-6" data-id="element-190">
            Reserve Your Wedding Date
          </h2>
          <p className="text-taupe text-lg mb-10" data-id="element-191">
            An elevated beauty experience begins here.
          </p>
          <Button href="/contact" variant="primary" data-id="element-192">
            Inquire for Bridal Booking
          </Button>
        </FadeIn>
      </section>
    </div>;
}